import EventDetailsV2Page from '@totem/components/services/threats/eventsDashboard/details/EventDetailsV2Page';
import EventsReportPage from '@totem/components/services/threats/eventsDashboard/report/EventsReportPage';
import EventsPage from '@totem/components/services/threats/EventsPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const eventRoutes: Route[] = [
  {
    path: 'events',
    pageTitle: 'Events',
    component: EventsReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Events' }],
    render: (userProfile: UserProfile) =>
      permissions.events.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'eventsv1',
    pageTitle: 'Events',
    component: EventsPage,
    exact: true,
    breadcrumbs: [{ label: 'Events' }],
    render: (userProfile: UserProfile) =>
      permissions.events.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'events/:id',
    pageTitle: 'Event',
    component: EventDetailsV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Events', link: '/events' }, { label: 'Event' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'events2',
    pageTitle: 'Events',
    component: EventsReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Events' }],
    render: (userProfile: UserProfile) =>
      permissions.events.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'events2/:id',
    pageTitle: 'Event',
    component: EventDetailsV2Page,
    exact: true,
    breadcrumbs: [{ label: 'Events', link: '/events2' }, { label: 'Event' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
